module.exports = __webpack_public_path__ + "static/media/login-1.c20b97f2.png";